import { fontMap } from "../utils/common";

export default function ConfirmBox({
  buttonText,
  text,
  extraText,
  open,
  setOpen,
  buttonHandler,
  extraButtonText,
  extraButtonHandler,
  selectedLang,
  showButton = true,
  thirdButtonText,
  thirdButtonHandler,
  thirdButtonCondition = false
}) {
  const handleClose = () => {
    if (buttonHandler) {
      buttonHandler();
    } else {
      setOpen(false);
    }
  };

  const fontFamilyCSS = fontMap[selectedLang?.lang] || "Lato";

  return (
    open && (
      <div
        style={{ zIndex: 999 }}
        className="relative"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          className="fixed inset-0 bg-black-150 opacity-70 transition-opacity"
          aria-hidden="true"
        ></div>

        <div
          style={{ zIndex: 999 }}
          className="fixed inset-0 w-screen overflow-y-auto"
        >
          <div className="flex min-h-full justify-center p-4 text-center items-center">
            <div className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all py-12 px-10 w-full max-w-lg">
              <div className="bg-white  flex flex-col items-center justify-center">
                {extraText && (
                  <div className="bg-[#FFF2ED] rounded py-2 px-3 mb-4 max-w-max">
                    <p
                      style={{ fontFamily: fontFamilyCSS }}
                      className="text-orange-150 text-sm font-semibold mb-0"
                    >
                      {extraText}
                    </p>
                  </div>
                )}
                <div className=" text-center">
                  <p
                    style={{ fontFamily: fontFamilyCSS }}
                    className="text-xl font-semibold text-black mb-0"
                  >
                    {text}
                  </p>
                </div>
              </div>
              {showButton && <div className="mt-6 flex flex-col items-center justify-center md:flex-row">
                <button
                  onClick={handleClose}
                  style={{ fontFamily: fontFamilyCSS }}
                  className="bg-orange-150 p-3 rounded-md text-lg font-bold mb-0 text-white"
                >
                  {buttonText}
                </button>
                {thirdButtonCondition && (
                  <button
                    style={{ fontFamily: fontFamilyCSS }}
                    onClick={thirdButtonHandler}
                    className="bg-orange-150 p-3 rounded-md text-lg font-bold mb-0 text-white mt-3 md:mt-0 md:ml-4"
                  >
                    {thirdButtonText}
                  </button>
                )}
                {extraButtonHandler && (
                  <button
                    style={{ fontFamily: fontFamilyCSS }}
                    onClick={extraButtonHandler}
                    className="bg-orange-150 p-3 rounded-md text-lg font-bold mb-0 text-white mt-3 md:mt-0 md:ml-4"
                  >
                    {extraButtonText}
                  </button>
                )}
              </div>}
            </div>
          </div>
        </div>
      </div>
    )
  );
}
